<template>
  <li
    :class="[
      'deck-tile-slides',
      'mb-1',
      'p-2',
      'pl-4',
      { 'bg-gray-100 rounded-md': selected },
      { 'bg-gray-100 -mx-2 pl-6 text-gray-500': disabled },
    ]"
    :data-testid="`deck-tile-${slide.id}`"
    :data-intercom-target="intercomId"
    :title="slide.title"
  >
    <p v-if="slide.type === 'H'" class="deck-tile-slides-header" data-testid="deck-tile-slides-header">{{ slide.title.toUpperCase() }}</p>
    <span v-else-if="slide.type === 'T'" data-testid="deck-tile-type-t" />
    <button
      v-else
      :disabled="disabled"
      :class="['appearance-none', , 'p-0', 'bg-transparent', 'w-full', 'outline-none', 'slide', { 'bg-gray-100': disabled }]"
      :title="disabled ? 'Slide not supported in Meetings' : slide.title"
      @click="$emit('on-slide-selected', index)"
    >
      <img v-if="slide.type == 'P'" class="slide-icon" src="~/assets/images/deck-icons/pdf-icon.png" draggable="false" />
      <img v-else-if="slide.type == 'I'" class="slide-icon" src="~/assets/images/deck-icons/image-icon.png" draggable="false" />
      <ThreeDIcon v-else-if="slide.type == 'M'" class="slide-icon" draggable="false" />
      <HotspotIcon v-else-if="slide.type == 'S'" class="slide-icon" draggable="false" />
      <DynamicIcon v-else-if="slide.type == 'D'" class="slide-icon" draggable="false" />
      <MeetingIcon v-else-if="slide.type == 'E'" class="slide-icon" draggable="false" />
      <FilmIcon v-else-if="slide.type == 'V'" class="slide-icon" draggable="false" />
      <span class="truncate">{{ slide.title }}</span>
    </button>
  </li>
</template>

<script lang="ts" setup>
import type { Slide } from '@/entities/deck'
import ThreeDIcon from '@/assets/images/deck-icons/threed-icon.svg'
import DynamicIcon from '@/assets/images/deck-icons/dynamic-icon.svg'
import MeetingIcon from '@/assets/images/deck-icons/meeting-icon.svg'
import HotspotIcon from '@/components/icons/site/hotspot-360.svg'
import { FilmIcon } from '@heroicons/vue/24/outline'
import type { DeepReadonly } from 'vue'

const props = defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    default: 0,
  },
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['on-slide-selected'])

const intercomId = computed(() => {
  switch (props.slide.type) {
    case 'H':
      return 'header-slide'
    case 'P':
      return 'pdf-slide'
    case 'I':
      return 'image-slide'
    case 'M':
      return '3d-slide'
    case 'S':
      return 'site-slide'
    case 'D':
      return 'dynamic-slide'
    case 'E':
      return 'bam-slide'
    case 'V':
      return 'video-slide'
    default:
      return ''
  }
})
</script>

<style lang="stylus" scoped>
.deck-tile-slides
  font-size 18px
  -moz-user-select none /* Firefox */
  -ms-user-select none /* Internet Explorer */
  -khtml-user-select none /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select none /* Chrome, Safari, and Opera */
  -webkit-touch-callout none /* Disable Android and iOS callouts*/

  .slide
    display flex
    align-items center
    white-space nowrap
    text-overflow ellipsis
    overflow hidden

    &-icon
      margin-right 10px
      width 25px
      height 25px
      flex-shrink 0

    span
      font-size 16px

  &-header
    font-size 18px
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
    max-width 400px
    color #c3c3c3
    margin-bottom 0
    letter-spacing 0.3px
</style>
